import React from 'react';
import { Box } from '@mui/material';

import { IAvailableCandidate } from '@types';
import {
  AvailableCategoryLabel,
  SHOW_CANDIDATE_MARKS,
  isAgileEngineer,
} from '@utils';
import { ListFiltersDialog } from 'components/candidate/CandidatesList/components/ListFiltersDialog';
import { ListHeader } from 'components/candidate/CandidatesList/components/ListHeader';
import { AgileEngineBenchStar } from './AgileEngineBenchStar';
import { AvailableCandidateFilterSections } from './AvailableCandidateFilterSections';
import { AvailableCandidatesSearch } from './AvailableCandidatesSearch';
import { ShowSkippedToggle } from './ShowSkippedToggle';
import { IAvailableCandidatesControls } from './controls';

const AVAILABLE_CANDIDATES_TITLE = 'Hot pipeline of available candidates';

interface IAvailableCandidatesHeaderProps {
  shown: IAvailableCandidate[];
  controls?: IAvailableCandidatesControls;
}

export const AvailableCandidatesHeader: React.FC<
  IAvailableCandidatesHeaderProps
> = ({ shown, controls }) => {
  const agileEngineers = shown.filter(isAgileEngineer).length;

  return (
    <ListHeader
      title={AVAILABLE_CANDIDATES_TITLE}
      filtersDialog={
        controls && (
          <ListFiltersDialog
            title={AVAILABLE_CANDIDATES_TITLE}
            activeFilterCount={controls.activeFilterCount}
            isDefault={controls.isDefault}
            onReset={controls.onReset}
            search={
              <AvailableCandidatesSearch
                fullWidth
                candidates={controls.candidates}
                value={controls.view.query}
                onChange={(query) => controls.onChange({ query })}
              />
            }
            controls={
              SHOW_CANDIDATE_MARKS && (
                <ShowSkippedToggle
                  view={controls.view}
                  count={controls.skippedCount}
                  onChange={controls.onChange}
                />
              )
            }
          >
            <AvailableCandidateFilterSections
              options={controls.filterOptions}
              filters={controls.view}
              onChange={controls.onChange}
            />
          </ListFiltersDialog>
        )
      }
      summary={
        shown.length > 0 && (
          <>
            {shown.length} pre-screened
            {agileEngineers > 0 && (
              <>
                {' · '}
                <Box
                  component="span"
                  display="inline-flex"
                  alignItems="center"
                  columnGap={0.5}
                  color="text.purple"
                >
                  {agileEngineers} {AvailableCategoryLabel.agileengineer}
                  <AgileEngineBenchStar />
                </Box>
              </>
            )}
          </>
        )
      }
    />
  );
};
